declare global {
  namespace Intl {
    interface Locale extends LocaleOptions {
      getWeekInfo: () => {
        firstDay: 1 | 7;
        weekend: number[];
        minimalDays?: number;
      };
    }
  }
}

if (!Intl.Locale.prototype["getWeekInfo"]) {
  Intl.Locale.prototype["getWeekInfo"] = function () {
    return (
      // FIXME: firefox doesn't want to have this whatsoever
      // We assume the starting of the week to be the Monday, but it's still a fallback
      this.weekInfo ?? {
        firstDay: 1,
        weekend: [6, 7],
      }
    );
  };
}

export {};
